/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { createFileRoute } from '@tanstack/react-router'

import { Route as rootRouteImport } from './routes/__root'
import { Route as R404RouteImport } from './routes/404'
import { Route as PaymentsAuthenticatedRouteImport } from './routes/payments/_authenticated'
import { Route as PaymentsRefundIdRouteImport } from './routes/payments/$refundId'
import { Route as PaymentsAuthenticatedThankYouRouteImport } from './routes/payments/_authenticated/thank-you'
import { Route as PaymentsAuthenticatedLayoutsRouteImport } from './routes/payments/_authenticated/_layouts'
import { Route as PaymentsAuthenticatedLayoutsPaymentMethodsIndexRouteImport } from './routes/payments/_authenticated/_layouts/payment-methods/index'
import { Route as PaymentsAuthenticatedLayoutsPaymentMethodsPaymentMethodsLayoutRouteImport } from './routes/payments/_authenticated/_layouts/payment-methods/_payment-methods-layout'
import { Route as PaymentsAuthenticatedLayoutsPaymentMethodsPaymentMethodsLayoutGiftCardsRouteImport } from './routes/payments/_authenticated/_layouts/payment-methods/_payment-methods-layout/gift-cards'
import { Route as PaymentsAuthenticatedLayoutsPaymentMethodsPaymentMethodsLayoutDonationRouteImport } from './routes/payments/_authenticated/_layouts/payment-methods/_payment-methods-layout/donation'
import { Route as PaymentsAuthenticatedLayoutsPaymentMethodsPaymentMethodsLayoutDirectDepositRouteImport } from './routes/payments/_authenticated/_layouts/payment-methods/_payment-methods-layout/direct-deposit'
import { Route as PaymentsAuthenticatedLayoutsPaymentMethodsPaymentMethodsLayoutDigitalPaymentsRouteImport } from './routes/payments/_authenticated/_layouts/payment-methods/_payment-methods-layout/digital-payments'
import { Route as PaymentsAuthenticatedLayoutsPaymentMethodsPaymentMethodsLayoutCheckRouteImport } from './routes/payments/_authenticated/_layouts/payment-methods/_payment-methods-layout/check'

const PaymentsRouteImport = createFileRoute('/payments')()
const IndexLazyRouteImport = createFileRoute('/')()
const PaymentsAuthenticatedLayoutsPaymentMethodsRouteImport = createFileRoute(
  '/payments/_authenticated/_layouts/payment-methods',
)()

const PaymentsRoute = PaymentsRouteImport.update({
  id: '/payments',
  path: '/payments',
  getParentRoute: () => rootRouteImport,
} as any)
const R404Route = R404RouteImport.update({
  id: '/404',
  path: '/404',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexLazyRoute = IndexLazyRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/index.lazy').then((d) => d.Route))
const PaymentsAuthenticatedRoute = PaymentsAuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => PaymentsRoute,
} as any)
const PaymentsRefundIdRoute = PaymentsRefundIdRouteImport.update({
  id: '/payments/$refundId',
  path: '/payments/$refundId',
  getParentRoute: () => rootRouteImport,
} as any)
const PaymentsAuthenticatedThankYouRoute =
  PaymentsAuthenticatedThankYouRouteImport.update({
    id: '/thank-you',
    path: '/thank-you',
    getParentRoute: () => PaymentsAuthenticatedRoute,
  } as any)
const PaymentsAuthenticatedLayoutsRoute =
  PaymentsAuthenticatedLayoutsRouteImport.update({
    id: '/_layouts',
    getParentRoute: () => PaymentsAuthenticatedRoute,
  } as any)
const PaymentsAuthenticatedLayoutsPaymentMethodsRoute =
  PaymentsAuthenticatedLayoutsPaymentMethodsRouteImport.update({
    id: '/payment-methods',
    path: '/payment-methods',
    getParentRoute: () => PaymentsAuthenticatedLayoutsRoute,
  } as any)
const PaymentsAuthenticatedLayoutsPaymentMethodsIndexRoute =
  PaymentsAuthenticatedLayoutsPaymentMethodsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => PaymentsAuthenticatedLayoutsPaymentMethodsRoute,
  } as any)
const PaymentsAuthenticatedLayoutsPaymentMethodsPaymentMethodsLayoutRoute =
  PaymentsAuthenticatedLayoutsPaymentMethodsPaymentMethodsLayoutRouteImport.update(
    {
      id: '/_payment-methods-layout',
      getParentRoute: () => PaymentsAuthenticatedLayoutsPaymentMethodsRoute,
    } as any,
  )
const PaymentsAuthenticatedLayoutsPaymentMethodsPaymentMethodsLayoutGiftCardsRoute =
  PaymentsAuthenticatedLayoutsPaymentMethodsPaymentMethodsLayoutGiftCardsRouteImport.update(
    {
      id: '/gift-cards',
      path: '/gift-cards',
      getParentRoute: () =>
        PaymentsAuthenticatedLayoutsPaymentMethodsPaymentMethodsLayoutRoute,
    } as any,
  )
const PaymentsAuthenticatedLayoutsPaymentMethodsPaymentMethodsLayoutDonationRoute =
  PaymentsAuthenticatedLayoutsPaymentMethodsPaymentMethodsLayoutDonationRouteImport.update(
    {
      id: '/donation',
      path: '/donation',
      getParentRoute: () =>
        PaymentsAuthenticatedLayoutsPaymentMethodsPaymentMethodsLayoutRoute,
    } as any,
  )
const PaymentsAuthenticatedLayoutsPaymentMethodsPaymentMethodsLayoutDirectDepositRoute =
  PaymentsAuthenticatedLayoutsPaymentMethodsPaymentMethodsLayoutDirectDepositRouteImport.update(
    {
      id: '/direct-deposit',
      path: '/direct-deposit',
      getParentRoute: () =>
        PaymentsAuthenticatedLayoutsPaymentMethodsPaymentMethodsLayoutRoute,
    } as any,
  )
const PaymentsAuthenticatedLayoutsPaymentMethodsPaymentMethodsLayoutDigitalPaymentsRoute =
  PaymentsAuthenticatedLayoutsPaymentMethodsPaymentMethodsLayoutDigitalPaymentsRouteImport.update(
    {
      id: '/digital-payments',
      path: '/digital-payments',
      getParentRoute: () =>
        PaymentsAuthenticatedLayoutsPaymentMethodsPaymentMethodsLayoutRoute,
    } as any,
  )
const PaymentsAuthenticatedLayoutsPaymentMethodsPaymentMethodsLayoutCheckRoute =
  PaymentsAuthenticatedLayoutsPaymentMethodsPaymentMethodsLayoutCheckRouteImport.update(
    {
      id: '/check',
      path: '/check',
      getParentRoute: () =>
        PaymentsAuthenticatedLayoutsPaymentMethodsPaymentMethodsLayoutRoute,
    } as any,
  )

export interface FileRoutesByFullPath {
  '/': typeof IndexLazyRoute
  '/404': typeof R404Route
  '/payments/$refundId': typeof PaymentsRefundIdRoute
  '/payments': typeof PaymentsAuthenticatedLayoutsRouteWithChildren
  '/payments/thank-you': typeof PaymentsAuthenticatedThankYouRoute
  '/payments/payment-methods': typeof PaymentsAuthenticatedLayoutsPaymentMethodsPaymentMethodsLayoutRouteWithChildren
  '/payments/payment-methods/': typeof PaymentsAuthenticatedLayoutsPaymentMethodsIndexRoute
  '/payments/payment-methods/check': typeof PaymentsAuthenticatedLayoutsPaymentMethodsPaymentMethodsLayoutCheckRoute
  '/payments/payment-methods/digital-payments': typeof PaymentsAuthenticatedLayoutsPaymentMethodsPaymentMethodsLayoutDigitalPaymentsRoute
  '/payments/payment-methods/direct-deposit': typeof PaymentsAuthenticatedLayoutsPaymentMethodsPaymentMethodsLayoutDirectDepositRoute
  '/payments/payment-methods/donation': typeof PaymentsAuthenticatedLayoutsPaymentMethodsPaymentMethodsLayoutDonationRoute
  '/payments/payment-methods/gift-cards': typeof PaymentsAuthenticatedLayoutsPaymentMethodsPaymentMethodsLayoutGiftCardsRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexLazyRoute
  '/404': typeof R404Route
  '/payments/$refundId': typeof PaymentsRefundIdRoute
  '/payments': typeof PaymentsAuthenticatedLayoutsRouteWithChildren
  '/payments/thank-you': typeof PaymentsAuthenticatedThankYouRoute
  '/payments/payment-methods': typeof PaymentsAuthenticatedLayoutsPaymentMethodsIndexRoute
  '/payments/payment-methods/check': typeof PaymentsAuthenticatedLayoutsPaymentMethodsPaymentMethodsLayoutCheckRoute
  '/payments/payment-methods/digital-payments': typeof PaymentsAuthenticatedLayoutsPaymentMethodsPaymentMethodsLayoutDigitalPaymentsRoute
  '/payments/payment-methods/direct-deposit': typeof PaymentsAuthenticatedLayoutsPaymentMethodsPaymentMethodsLayoutDirectDepositRoute
  '/payments/payment-methods/donation': typeof PaymentsAuthenticatedLayoutsPaymentMethodsPaymentMethodsLayoutDonationRoute
  '/payments/payment-methods/gift-cards': typeof PaymentsAuthenticatedLayoutsPaymentMethodsPaymentMethodsLayoutGiftCardsRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexLazyRoute
  '/404': typeof R404Route
  '/payments/$refundId': typeof PaymentsRefundIdRoute
  '/payments': typeof PaymentsRouteWithChildren
  '/payments/_authenticated': typeof PaymentsAuthenticatedRouteWithChildren
  '/payments/_authenticated/_layouts': typeof PaymentsAuthenticatedLayoutsRouteWithChildren
  '/payments/_authenticated/thank-you': typeof PaymentsAuthenticatedThankYouRoute
  '/payments/_authenticated/_layouts/payment-methods': typeof PaymentsAuthenticatedLayoutsPaymentMethodsRouteWithChildren
  '/payments/_authenticated/_layouts/payment-methods/_payment-methods-layout': typeof PaymentsAuthenticatedLayoutsPaymentMethodsPaymentMethodsLayoutRouteWithChildren
  '/payments/_authenticated/_layouts/payment-methods/': typeof PaymentsAuthenticatedLayoutsPaymentMethodsIndexRoute
  '/payments/_authenticated/_layouts/payment-methods/_payment-methods-layout/check': typeof PaymentsAuthenticatedLayoutsPaymentMethodsPaymentMethodsLayoutCheckRoute
  '/payments/_authenticated/_layouts/payment-methods/_payment-methods-layout/digital-payments': typeof PaymentsAuthenticatedLayoutsPaymentMethodsPaymentMethodsLayoutDigitalPaymentsRoute
  '/payments/_authenticated/_layouts/payment-methods/_payment-methods-layout/direct-deposit': typeof PaymentsAuthenticatedLayoutsPaymentMethodsPaymentMethodsLayoutDirectDepositRoute
  '/payments/_authenticated/_layouts/payment-methods/_payment-methods-layout/donation': typeof PaymentsAuthenticatedLayoutsPaymentMethodsPaymentMethodsLayoutDonationRoute
  '/payments/_authenticated/_layouts/payment-methods/_payment-methods-layout/gift-cards': typeof PaymentsAuthenticatedLayoutsPaymentMethodsPaymentMethodsLayoutGiftCardsRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/404'
    | '/payments/$refundId'
    | '/payments'
    | '/payments/thank-you'
    | '/payments/payment-methods'
    | '/payments/payment-methods/'
    | '/payments/payment-methods/check'
    | '/payments/payment-methods/digital-payments'
    | '/payments/payment-methods/direct-deposit'
    | '/payments/payment-methods/donation'
    | '/payments/payment-methods/gift-cards'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/404'
    | '/payments/$refundId'
    | '/payments'
    | '/payments/thank-you'
    | '/payments/payment-methods'
    | '/payments/payment-methods/check'
    | '/payments/payment-methods/digital-payments'
    | '/payments/payment-methods/direct-deposit'
    | '/payments/payment-methods/donation'
    | '/payments/payment-methods/gift-cards'
  id:
    | '__root__'
    | '/'
    | '/404'
    | '/payments/$refundId'
    | '/payments'
    | '/payments/_authenticated'
    | '/payments/_authenticated/_layouts'
    | '/payments/_authenticated/thank-you'
    | '/payments/_authenticated/_layouts/payment-methods'
    | '/payments/_authenticated/_layouts/payment-methods/_payment-methods-layout'
    | '/payments/_authenticated/_layouts/payment-methods/'
    | '/payments/_authenticated/_layouts/payment-methods/_payment-methods-layout/check'
    | '/payments/_authenticated/_layouts/payment-methods/_payment-methods-layout/digital-payments'
    | '/payments/_authenticated/_layouts/payment-methods/_payment-methods-layout/direct-deposit'
    | '/payments/_authenticated/_layouts/payment-methods/_payment-methods-layout/donation'
    | '/payments/_authenticated/_layouts/payment-methods/_payment-methods-layout/gift-cards'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexLazyRoute: typeof IndexLazyRoute
  R404Route: typeof R404Route
  PaymentsRefundIdRoute: typeof PaymentsRefundIdRoute
  PaymentsRoute: typeof PaymentsRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/payments': {
      id: '/payments'
      path: '/payments'
      fullPath: '/payments'
      preLoaderRoute: typeof PaymentsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/404': {
      id: '/404'
      path: '/404'
      fullPath: '/404'
      preLoaderRoute: typeof R404RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexLazyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/payments/_authenticated': {
      id: '/payments/_authenticated'
      path: '/payments'
      fullPath: '/payments'
      preLoaderRoute: typeof PaymentsAuthenticatedRouteImport
      parentRoute: typeof PaymentsRoute
    }
    '/payments/$refundId': {
      id: '/payments/$refundId'
      path: '/payments/$refundId'
      fullPath: '/payments/$refundId'
      preLoaderRoute: typeof PaymentsRefundIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/payments/_authenticated/thank-you': {
      id: '/payments/_authenticated/thank-you'
      path: '/thank-you'
      fullPath: '/payments/thank-you'
      preLoaderRoute: typeof PaymentsAuthenticatedThankYouRouteImport
      parentRoute: typeof PaymentsAuthenticatedRoute
    }
    '/payments/_authenticated/_layouts': {
      id: '/payments/_authenticated/_layouts'
      path: ''
      fullPath: '/payments'
      preLoaderRoute: typeof PaymentsAuthenticatedLayoutsRouteImport
      parentRoute: typeof PaymentsAuthenticatedRoute
    }
    '/payments/_authenticated/_layouts/payment-methods': {
      id: '/payments/_authenticated/_layouts/payment-methods'
      path: '/payment-methods'
      fullPath: '/payments/payment-methods'
      preLoaderRoute: typeof PaymentsAuthenticatedLayoutsPaymentMethodsRouteImport
      parentRoute: typeof PaymentsAuthenticatedLayoutsRoute
    }
    '/payments/_authenticated/_layouts/payment-methods/': {
      id: '/payments/_authenticated/_layouts/payment-methods/'
      path: '/'
      fullPath: '/payments/payment-methods/'
      preLoaderRoute: typeof PaymentsAuthenticatedLayoutsPaymentMethodsIndexRouteImport
      parentRoute: typeof PaymentsAuthenticatedLayoutsPaymentMethodsRoute
    }
    '/payments/_authenticated/_layouts/payment-methods/_payment-methods-layout': {
      id: '/payments/_authenticated/_layouts/payment-methods/_payment-methods-layout'
      path: '/payment-methods'
      fullPath: '/payments/payment-methods'
      preLoaderRoute: typeof PaymentsAuthenticatedLayoutsPaymentMethodsPaymentMethodsLayoutRouteImport
      parentRoute: typeof PaymentsAuthenticatedLayoutsPaymentMethodsRoute
    }
    '/payments/_authenticated/_layouts/payment-methods/_payment-methods-layout/gift-cards': {
      id: '/payments/_authenticated/_layouts/payment-methods/_payment-methods-layout/gift-cards'
      path: '/gift-cards'
      fullPath: '/payments/payment-methods/gift-cards'
      preLoaderRoute: typeof PaymentsAuthenticatedLayoutsPaymentMethodsPaymentMethodsLayoutGiftCardsRouteImport
      parentRoute: typeof PaymentsAuthenticatedLayoutsPaymentMethodsPaymentMethodsLayoutRoute
    }
    '/payments/_authenticated/_layouts/payment-methods/_payment-methods-layout/donation': {
      id: '/payments/_authenticated/_layouts/payment-methods/_payment-methods-layout/donation'
      path: '/donation'
      fullPath: '/payments/payment-methods/donation'
      preLoaderRoute: typeof PaymentsAuthenticatedLayoutsPaymentMethodsPaymentMethodsLayoutDonationRouteImport
      parentRoute: typeof PaymentsAuthenticatedLayoutsPaymentMethodsPaymentMethodsLayoutRoute
    }
    '/payments/_authenticated/_layouts/payment-methods/_payment-methods-layout/direct-deposit': {
      id: '/payments/_authenticated/_layouts/payment-methods/_payment-methods-layout/direct-deposit'
      path: '/direct-deposit'
      fullPath: '/payments/payment-methods/direct-deposit'
      preLoaderRoute: typeof PaymentsAuthenticatedLayoutsPaymentMethodsPaymentMethodsLayoutDirectDepositRouteImport
      parentRoute: typeof PaymentsAuthenticatedLayoutsPaymentMethodsPaymentMethodsLayoutRoute
    }
    '/payments/_authenticated/_layouts/payment-methods/_payment-methods-layout/digital-payments': {
      id: '/payments/_authenticated/_layouts/payment-methods/_payment-methods-layout/digital-payments'
      path: '/digital-payments'
      fullPath: '/payments/payment-methods/digital-payments'
      preLoaderRoute: typeof PaymentsAuthenticatedLayoutsPaymentMethodsPaymentMethodsLayoutDigitalPaymentsRouteImport
      parentRoute: typeof PaymentsAuthenticatedLayoutsPaymentMethodsPaymentMethodsLayoutRoute
    }
    '/payments/_authenticated/_layouts/payment-methods/_payment-methods-layout/check': {
      id: '/payments/_authenticated/_layouts/payment-methods/_payment-methods-layout/check'
      path: '/check'
      fullPath: '/payments/payment-methods/check'
      preLoaderRoute: typeof PaymentsAuthenticatedLayoutsPaymentMethodsPaymentMethodsLayoutCheckRouteImport
      parentRoute: typeof PaymentsAuthenticatedLayoutsPaymentMethodsPaymentMethodsLayoutRoute
    }
  }
}

interface PaymentsAuthenticatedLayoutsPaymentMethodsPaymentMethodsLayoutRouteChildren {
  PaymentsAuthenticatedLayoutsPaymentMethodsPaymentMethodsLayoutCheckRoute: typeof PaymentsAuthenticatedLayoutsPaymentMethodsPaymentMethodsLayoutCheckRoute
  PaymentsAuthenticatedLayoutsPaymentMethodsPaymentMethodsLayoutDigitalPaymentsRoute: typeof PaymentsAuthenticatedLayoutsPaymentMethodsPaymentMethodsLayoutDigitalPaymentsRoute
  PaymentsAuthenticatedLayoutsPaymentMethodsPaymentMethodsLayoutDirectDepositRoute: typeof PaymentsAuthenticatedLayoutsPaymentMethodsPaymentMethodsLayoutDirectDepositRoute
  PaymentsAuthenticatedLayoutsPaymentMethodsPaymentMethodsLayoutDonationRoute: typeof PaymentsAuthenticatedLayoutsPaymentMethodsPaymentMethodsLayoutDonationRoute
  PaymentsAuthenticatedLayoutsPaymentMethodsPaymentMethodsLayoutGiftCardsRoute: typeof PaymentsAuthenticatedLayoutsPaymentMethodsPaymentMethodsLayoutGiftCardsRoute
}

const PaymentsAuthenticatedLayoutsPaymentMethodsPaymentMethodsLayoutRouteChildren: PaymentsAuthenticatedLayoutsPaymentMethodsPaymentMethodsLayoutRouteChildren =
  {
    PaymentsAuthenticatedLayoutsPaymentMethodsPaymentMethodsLayoutCheckRoute:
      PaymentsAuthenticatedLayoutsPaymentMethodsPaymentMethodsLayoutCheckRoute,
    PaymentsAuthenticatedLayoutsPaymentMethodsPaymentMethodsLayoutDigitalPaymentsRoute:
      PaymentsAuthenticatedLayoutsPaymentMethodsPaymentMethodsLayoutDigitalPaymentsRoute,
    PaymentsAuthenticatedLayoutsPaymentMethodsPaymentMethodsLayoutDirectDepositRoute:
      PaymentsAuthenticatedLayoutsPaymentMethodsPaymentMethodsLayoutDirectDepositRoute,
    PaymentsAuthenticatedLayoutsPaymentMethodsPaymentMethodsLayoutDonationRoute:
      PaymentsAuthenticatedLayoutsPaymentMethodsPaymentMethodsLayoutDonationRoute,
    PaymentsAuthenticatedLayoutsPaymentMethodsPaymentMethodsLayoutGiftCardsRoute:
      PaymentsAuthenticatedLayoutsPaymentMethodsPaymentMethodsLayoutGiftCardsRoute,
  }

const PaymentsAuthenticatedLayoutsPaymentMethodsPaymentMethodsLayoutRouteWithChildren =
  PaymentsAuthenticatedLayoutsPaymentMethodsPaymentMethodsLayoutRoute._addFileChildren(
    PaymentsAuthenticatedLayoutsPaymentMethodsPaymentMethodsLayoutRouteChildren,
  )

interface PaymentsAuthenticatedLayoutsPaymentMethodsRouteChildren {
  PaymentsAuthenticatedLayoutsPaymentMethodsPaymentMethodsLayoutRoute: typeof PaymentsAuthenticatedLayoutsPaymentMethodsPaymentMethodsLayoutRouteWithChildren
  PaymentsAuthenticatedLayoutsPaymentMethodsIndexRoute: typeof PaymentsAuthenticatedLayoutsPaymentMethodsIndexRoute
}

const PaymentsAuthenticatedLayoutsPaymentMethodsRouteChildren: PaymentsAuthenticatedLayoutsPaymentMethodsRouteChildren =
  {
    PaymentsAuthenticatedLayoutsPaymentMethodsPaymentMethodsLayoutRoute:
      PaymentsAuthenticatedLayoutsPaymentMethodsPaymentMethodsLayoutRouteWithChildren,
    PaymentsAuthenticatedLayoutsPaymentMethodsIndexRoute:
      PaymentsAuthenticatedLayoutsPaymentMethodsIndexRoute,
  }

const PaymentsAuthenticatedLayoutsPaymentMethodsRouteWithChildren =
  PaymentsAuthenticatedLayoutsPaymentMethodsRoute._addFileChildren(
    PaymentsAuthenticatedLayoutsPaymentMethodsRouteChildren,
  )

interface PaymentsAuthenticatedLayoutsRouteChildren {
  PaymentsAuthenticatedLayoutsPaymentMethodsRoute: typeof PaymentsAuthenticatedLayoutsPaymentMethodsRouteWithChildren
}

const PaymentsAuthenticatedLayoutsRouteChildren: PaymentsAuthenticatedLayoutsRouteChildren =
  {
    PaymentsAuthenticatedLayoutsPaymentMethodsRoute:
      PaymentsAuthenticatedLayoutsPaymentMethodsRouteWithChildren,
  }

const PaymentsAuthenticatedLayoutsRouteWithChildren =
  PaymentsAuthenticatedLayoutsRoute._addFileChildren(
    PaymentsAuthenticatedLayoutsRouteChildren,
  )

interface PaymentsAuthenticatedRouteChildren {
  PaymentsAuthenticatedLayoutsRoute: typeof PaymentsAuthenticatedLayoutsRouteWithChildren
  PaymentsAuthenticatedThankYouRoute: typeof PaymentsAuthenticatedThankYouRoute
}

const PaymentsAuthenticatedRouteChildren: PaymentsAuthenticatedRouteChildren = {
  PaymentsAuthenticatedLayoutsRoute:
    PaymentsAuthenticatedLayoutsRouteWithChildren,
  PaymentsAuthenticatedThankYouRoute: PaymentsAuthenticatedThankYouRoute,
}

const PaymentsAuthenticatedRouteWithChildren =
  PaymentsAuthenticatedRoute._addFileChildren(
    PaymentsAuthenticatedRouteChildren,
  )

interface PaymentsRouteChildren {
  PaymentsAuthenticatedRoute: typeof PaymentsAuthenticatedRouteWithChildren
}

const PaymentsRouteChildren: PaymentsRouteChildren = {
  PaymentsAuthenticatedRoute: PaymentsAuthenticatedRouteWithChildren,
}

const PaymentsRouteWithChildren = PaymentsRoute._addFileChildren(
  PaymentsRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexLazyRoute: IndexLazyRoute,
  R404Route: R404Route,
  PaymentsRefundIdRoute: PaymentsRefundIdRoute,
  PaymentsRoute: PaymentsRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
